<template>
  <div class="info" :style="layoutDirection === 'column' ? column : row">
    <div v-if="showImage" class="col">
      <template v-for="(item, index) in titles">
        <div v-if="item.inputType === 'image'" :key="index">
          <!-- <img class="avatar" v-if="infos.attrs[item.name] && infos.attrs[item.name] !== ' ' && infos.attrs[item.name] !== '_'"  :src="infos.attrs[item.name]"> -->
          <img class="avatar" v-if="infos.attrs[item.name] && infos.attrs[item.name] !== ' ' && infos.attrs[item.name] !== '_'"  :src="infos.attrs[item.name]" onerror="this.src='/img/person_default.png'">
          <!-- <div class="empty" v-else>
            <div>未上传照片</div>
          </div> -->
          <img class="avatar" v-else  src="../../../assets/person_default.png">
        </div>
      </template>
    </div>

    <div class="col">
      <template v-for="(item, index) in titles">
        <div v-if="item.inputType !== 'image' && item.name !== '矫正计划' && item.name !== 'Correct Plan'" :key="index">
          <div class="attr" >
            <div class="key">{{extendStringWithSpace($t(`columnCheck.${item.name}`)) + ':'}}</div>
            <div class="value" v-if="item.name === '性别' || item.name === 'Male'">
              {{infos.attrs[item.name]}}
              <zx-icon :type="infos.attrs[item.name] === $t('supervise.male') ? 'icon-nan2' : 'icon-nv2'"></zx-icon>
            </div>
            <div class="value" v-else-if="item.inputType === 'date'">{{ infos.attrs[item.name] ?  moment(infos.attrs[item.name] * 1000).format('YYYY-MM-DD') + `     (${computedAge(infos.attrs[item.name]) + $t('home.age')})` : '---'}}</div>
            <div class="value" v-else>{{infos.attrs[item.name] || '---'}}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="col">
      <template v-for="(item, key, index) in correctInfos">
        <div class="attr" :key="index">
          <div class="key">{{extendStringWithSpace(key) + ':'}}</div>
          <div class="value" v-if="key === $t('supervise.isBindDevice')">
            {{item ? $t('home.weared') : $t('home.nonWeared')}}
            <i :class="item ? 'icon-online' : 'icon-offline'">
              <zx-icon type="icon-wanbiaobangding"></zx-icon>
            </i>
          </div>
          <div class="value" v-else-if="key === $t('supervise.absent')">
            {{item.startTime ? formatTime(item.startTime) + '~' + formatTime(item.endTime) : '---'}}
            <!-- <i v-if="item" class="icon-online">
              <zx-icon type="icon-qingjia"></zx-icon>
            </i> -->
          </div>
          <div class="value" v-else-if="key === $t('supervise.group')">
            {{computeGroup(item)}}
          </div>
          <div class="value" v-else>{{item}}</div>
        </div>
      </template>
      <!-- {{correctInfos}} -->
    </div>
  </div>
</template>
<script>
import defaultPng from '../../../assets/person_default.png'
import moment from 'moment'
import {extendStringWithSpace} from '../../../utils/homeFn'
export default {
  // props: ['titles', 'infos'],
  props: {
    titles: {
      required: true,
      type: Array
    },
    infos: {
      required: true
    },
    showImage: {
      default: true,
      type: Boolean
    },
    layoutDirection: {
      default: 'column'
    }
  },
  data () {
    return {
      column: {
        gridTemplateColumns: '200px 350px 1fr'
      },
      row: {
        gridTemplateRows: 'auto'
      },
      defaultPng
    }
  },
  mounted () {
    // console.log(this.infos)
  },
  methods: {
    moment,
    extendStringWithSpace,
    computedAge (birthDay) {
      // console.log(moment.duration(moment().diff(birthDay * 1000)).humanize())
      return moment.duration(moment().diff(birthDay * 1000)).years()
    },
    formatTime (timeStamp, onlyDay=false) {
      if (onlyDay) {
        return moment(timeStamp * 1000).format('YYYY-MM-DD')
      } else {
        return moment(timeStamp * 1000).format('YYYY-MM-DD HH:mm')
      }
    },
    computeGroup(item){
      console.log(item);
      switch(item){
        case '宽管组':case '严管组':case '普管组':
          return this.$t('global.' + item)
        default:
        return item
      }
    }
  },
  computed: {
    correctInfos () {
      if (this.infos.absent) {
        return {
          [this.$t('supervise.superviseOrg')]: this.infos.orgName,
          [this.$t('supervise.group')]: this.infos.groupName,
          [this.$t('supervise.correctTime')]: this.formatTime(this.infos.executeTime, true),
          [this.$t('supervise.correctPlan')]: this.infos.attrs[this.$t('supervise.correctPlan')] || '---',
          [this.$t('supervise.absent')]: this.infos.absent,
          [this.$t('supervise.isBindDevice')]: this.infos.wearWatch
        }
      } else {
        return {
          [this.$t('supervise.superviseOrg')]: this.infos.orgName,
          [this.$t('supervise.group')]: this.infos.groupName,
          [this.$t('supervise.correctTime')]: this.formatTime(this.infos.executeTime, true),
          [this.$t('supervise.correctPlan')]: this.infos.attrs[this.$t('supervise.correctPlan')] || '---',
          [this.$t('supervise.isBindDevice')]: this.infos.wearWatch
        }
      }
    },
  
  }
}
</script>
<style lang="less" scoped>
@import '../../../theme/color.less';
.info {
  width: 100%;
  // display: flex;
  // flex-direction: row;
  display: grid;
  // grid-template-columns: 200px 350px 1fr;
  // grid-template-rows: auto;
  justify-content: space-between;
  .col {
    padding: 0 30px;
    .attr {
      display: flex;
      font-size: 1.1em;
      padding-bottom: 5px; 
      .key {
        color: @text-color;
      }
      .value {
        color: @heading-color;
        margin-left: 10px;
      }
    }
    .avatar {
      max-width: 100px;
    }
    .empty {
      width: 70px;
      height: 98px;
      border: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #999;
      font-size: 11px;
    }
  }
}
</style>